var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-table", {
    ref: "logTable",
    staticClass: "sticky-header-table first-column-sticky",
    attrs: {
      data: _vm.tableData,
      columns: _vm.columns,
      "visible-columns": _vm.visibleColumns,
      pagination: _vm.pagination,
      loading: _vm.loadingLogs,
      "rows-per-page-options": _vm.rowsPerPageOptions,
      "pagination-label": _vm.getPaginationLabel,
      "row-key": "intLogId"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      },
      request: _vm.onRequest
    },
    scopedSlots: _vm._u([
      {
        key: "loading",
        fn: function() {
          return [
            _c("q-inner-loading", { attrs: { showing: "", color: "primary" } })
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function(props) {
          return [
            _c("veneer-log-table-row", {
              attrs: {
                props: props,
                "emit-log": _vm.emitLog,
                "show-active-watchlist-check": true
              },
              on: {
                click: function(log) {
                  return _vm.$emit("click", log)
                }
              }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }